import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import Publications from './components/Publications';
import Contact from './components/Contact';
import publicationData from './data/publicationData';
import bannerData from './data/bannerData';

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div style={{minHeight: "100vh", display: "flex", flexDirection: "column"}}>
          <Header />
          <div>
            <Route exact path="/" component={Home} />
            <Route path="/publications" render={ () => <Publications publicationType={publicationData} /> } />
            <Route path="/cornishbanner" render={ () => <Publications publicationType={bannerData} /> } />
            <Route path="/contact" component={Contact} />
          </div>
          <Footer />
        </div>
      </BrowserRouter>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js